/* global axios */
import ApiClient from './ApiClient';

class LaisSettingsAPI extends ApiClient {
  constructor() {
    super('lais_settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, payload);
  }

  // SPEC 41 / P37-18 — perfil "Meus Negócios".
  get businessProfileUrl() {
    return `${this.baseUrl()}/lais/business_profile`;
  }

  getBusinessProfile() {
    return axios.get(this.businessProfileUrl);
  }

  updateBusinessProfile(businessProfile) {
    return axios.put(this.businessProfileUrl, {
      business_profile: businessProfile,
    });
  }
}

export default new LaisSettingsAPI();
